import React from 'react';
import OutsideFormInput from 'components/Input/OutsideFormInput';

interface IM4PasswordField {
	value: string;
	settingsId: string;
	onChange: (value: string) => void;
}

const M4PasswordField: React.FC<IM4PasswordField> = ({ onChange, value, settingsId }) => {
	return (
		<OutsideFormInput
			testId="M4PasswordField"
			name="password"
			label="APIProxiPasswordHashLabel"
			errorMessage="enterPassword"
			blockId={settingsId}
			value={value}
			onChange={onChange}
		/>
	);
};

export default React.memo(M4PasswordField);
